export default function scrollToBlocks() {
    const blocks = document.querySelectorAll('[data-scroll-to]');
    console.log('scrollToBlocks');
    if (blocks.length === 0) return;

    blocks.forEach(block => {
        const targetQuery = block.getAttribute('data-scroll-to');
        if (targetQuery === '') return;

        const targetBlock = document.querySelector(targetQuery);
        const y = targetBlock.getBoundingClientRect().top + window.scrollY - getHeaderHeight();

        block.addEventListener('click', function(e) {
            e.preventDefault();
            window.scroll({
                top: y,
                behavior: "smooth",
            });
        })
    })
}

function getHeaderHeight() {
    const header = document.querySelector('.header');
    return header.clientHeight - 1
}